import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseNearMe: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0303 3.96969C20.2425 4.18184 20.3078 4.5 20.1964 4.77856L13.1964 22.2786C13.0714 22.5909 12.7538 22.7818 12.4194 22.7457C12.085 22.7095 11.8155 22.4551 11.7602 22.1233L10.3483 13.6517L1.8767 12.2398C1.54489 12.1845 1.29049 11.9151 1.25434 11.5806C1.21819 11.2462 1.40913 10.9286 1.72145 10.8037L19.2215 3.80366C19.5 3.69224 19.8182 3.75754 20.0303 3.96969ZM4.76727 11.2009L11.1233 12.2602C11.4394 12.3129 11.6871 12.5606 11.7398 12.8767L12.7991 19.2327L18.1537 5.84631L4.76727 11.2009Z"
        fill={color}
      />
    </svg>
  );
};
